import React from 'react';
import PolicyChange from '../PolicyChange';
import ChangedFields from '../ChangedFields';
import DriverFields from './DriverFields';

const DriverChangeConfirm = ({ policy, data, onComplete, onSaveAndExit, onEdit, onCancel, isAdd, rate }) => {
	if (!rate) return null;
	
	return (
		<div>
			<PolicyChange name='Driver' policy={policy} rate={rate} onComplete={onComplete} onSaveAndExit={onSaveAndExit} onEdit={onEdit} onCancel={onCancel} title={`Please review and complete ${isAdd ? 'adding' : 'editing'} the driver`} showEdit hideConfirm={isAdd}>
				<ChangedFields fields={DriverFields} changedFields={data.changedFields} originalData={data.originalDriver} data={data} isAdd={isAdd} />
			</PolicyChange>
		</div>
	);
};

DriverChangeConfirm.propTypes = {};

export default DriverChangeConfirm;
